import { CMI_DIGEST_WATCHLIST_TYPE, CmiDigestWatchlistType } from 'types/cmiDigestWatchlist';

export const TYPE_FILTER_OPTIONS: { label: string; value: CmiDigestWatchlistType }[] = [
  { label: 'Any', value: CMI_DIGEST_WATCHLIST_TYPE.ANY },
  { label: 'Needs Attention', value: CMI_DIGEST_WATCHLIST_TYPE.NEEDS_ATTENTION },
  { label: 'Other', value: CMI_DIGEST_WATCHLIST_TYPE.OTHER },
  { label: 'With New Competitor Incentives', value: CMI_DIGEST_WATCHLIST_TYPE.INCENTIVES },
  { label: 'With New Reviews', value: CMI_DIGEST_WATCHLIST_TYPE.REVIEWS },
];
